import axios from 'axios'

var qs = require("qs")
var root = window.API_ROOT
var ossipath = window.OSSI_Path
var ossizyj = window.OSSI_ZYJ

//multipart/form-data
//application/x-www-form-urlencoded

//登录
export const login = (params) => {
  var op = ossipath;
  var userZYJ = false;
  if (params.idencode && params.idencode.indexOf('TZYJ：') == 0) {
    op = ossizyj;
    params.idencode = params.idencode.replace('TZYJ：', '')
    userZYJ = true;
  }
  return axios.post(op + '/ossi/login', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}}).then(res => {
    if (userZYJ && res && res.data.msg) {
      res.data.msg = 'TZYJ：' + res.data.msg;
    }
    return res;
  }).catch(err => {
    return Promise.reject(err);
  });
}

export const ssoBuyWeb = (params) => {
  return axios.post(root + '/ossi/ssoBuyWeb', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//余额
export const accountBalance = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/accountBalance', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getBalabceRecharge = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/getBalabceRecharge', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getCashRecharge = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/getCashRecharge', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const getdetailGoods = (params,ssotoken) => {
  return axios.post(ossipath + '/set/jxcgoodsdetail/getdetailapp', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const supplyCategory = (params,ssotoken) => {
  return axios.post(ossipath + '/set/jxcgoodscategory/list', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const supplyGoods = (params,ssotoken) => {
  return axios.post(ossipath + '/set/jxcgoodsdetail/listapp', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const supplyGoodsdetail = (params,ssotoken) => {
  return axios.post(ossipath + '/set/jxcgoodsdetail/getdetailapp', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const createOrder = (params,ssotoken) => {
  if(ssotoken.split('?')[0]=='http://thisapi'){
    params["ssosecret"]=ssotoken.split('?')[2];
    return axios.post(root + ssotoken.split('?')[1], qs.stringify(params))
  }else {
    var op = ossipath;
    if (ssotoken && ssotoken.indexOf('TZYJ：') == 0) {
      op = ossizyj;
      ssotoken = ssotoken.replace('TZYJ：', '')
    }

    return axios.post(op + '/ossi/createOrder', qs.stringify(params), {
      ssotoken: ssotoken,
      headers: {"Content-Type": "application/x-www-form-urlencoded"}
    });
  }
}

export const checkOrderPay = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/checkOrderPay', qs.stringify(params), {ssotoken: ssotoken,noloading:true,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}
export const createFrameOrder = (params,ssotoken) => {
  return axios.post(ossipath + '/zyjossi/createFrameOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}
export const supplystoreNum = (params,ssotoken) => {
  return axios.post(ossipath + '/warehouse/store/storeNum', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const backOrder = (params,ssotoken) => {
  var op = ossipath;
  if (ssotoken && ssotoken.indexOf('TZYJ：') == 0) {
    op = ossizyj;
    ssotoken = ssotoken.replace('TZYJ：', '')
  }
  return axios.post(op + '/ossi/backOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listOrder = (params,ssotoken) => {
  var op = ossipath;
  if (ssotoken && ssotoken.indexOf('TZYJ：') == 0) {
    op = ossizyj;
    ssotoken = ssotoken.replace('TZYJ：', '')
  }
  return axios.post(op + '/ossi/listOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const detailOrder = (params,ssotoken) => {
  var op = ossipath;
  if (ssotoken && ssotoken.indexOf('TZYJ：') == 0) {
    op = ossizyj;
    ssotoken = ssotoken.replace('TZYJ：', '')
  }
  return axios.post(op + '/ossi/detailOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const relatedOrder = (params,ssotoken) => {
  var op = ossipath;
  if (ssotoken && ssotoken.indexOf('TZYJ：') == 0) {
    op = ossizyj;
    ssotoken = ssotoken.replace('TZYJ：', '')
  }
  return axios.post(op + '/ossi/relatedOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}



export const regist = (params) => {
  var op = ossipath;
  if (params.totenantid && params.totenantid.indexOf('TZYJ：') == 0) {
    op = ossizyj;
    params.totenantid = params.totenantid.replace('TZYJ：', '')
  }
  return axios.post(op + '/ossi/regist', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const registCheck = (params) => {
  var op = ossipath;
  if (params.idencode && params.idencode.indexOf('TZYJ：') == 0) {
    op = ossizyj;
    params.idencode = params.idencode.replace('TZYJ：', '')
  }
  return axios.post(op + '/ossi/registCheck', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const registDraw = (params) => {
  var op = ossipath;
  if (params.idencode && params.idencode.indexOf('TZYJ：') == 0) {
    op = ossizyj;
    params.idencode = params.idencode.replace('TZYJ：', '')
  }
  return axios.post(op + '/ossi/registDraw', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listSupplier = (params) => {
  return axios.post(ossipath + '/ossi/listSupplier', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const empower = (params) => {
  return axios.post(root + '/ossi/empower', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listempower = (params) => {
  return axios.post(root + '/ossi/listempower', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}



// WEBPACK FOOTER //
// ./src/api/ossi.js